import PropTypes from 'prop-types';
import { loginMainImage, loginMainImageMobile } from '../api/loginImages.js';

const LOGIN_HERO_SRCSET = `${loginMainImageMobile} 380w, ${loginMainImage} 616w`;
const LOGIN_HERO_SIZES = '(max-width: 768px) calc(100vw - 32px), 616px';

export default function AuthMainImage({ className = 'main-image', alt = 'Decorative jewelry photography' }) {
    return (
        <picture>
            <source media="(min-width: 769px)" srcSet={loginMainImage} />
            <img
                className={className}
                src={loginMainImageMobile}
                srcSet={LOGIN_HERO_SRCSET}
                sizes={LOGIN_HERO_SIZES}
                alt={alt}
                width={616}
                height={897}
                loading="eager"
                fetchPriority="high"
                decoding="sync"
            />
        </picture>
    );
}

AuthMainImage.propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string,
};

export { LOGIN_HERO_SRCSET, LOGIN_HERO_SIZES };
